import { Anchor, Box, Tag, TAG_APPEARANCES } from '@zillow/constellation';
import { uniqBy } from 'lodash';
import React from 'react';

import { PostCategoriesProps } from './PostCategories.types';

const isGray = (color: string) =>
    ['gray', 'closeable', 'transparent'].includes(color);
const TAG_APPEARANCES_ARRAY = Object.values(TAG_APPEARANCES).filter(
    (color) => !isGray(color as string)
);

const wrap = (min: number, max: number, value: number): number => {
    const range = max - min + 1;
    return ((((value - min) % range) + range) % range) + min;
};

const PostCategories: React.FC<PostCategoriesProps> = ({
    categories = [],
    primaryCategory,
}) => {
    if (!categories.length && !primaryCategory) {
        return null;
    }

    const uniqueCategories = uniqBy(
        primaryCategory ? [primaryCategory, ...categories] : categories,
        'id'
    ).filter(Boolean);

    return (
        <Box
            sx={{
                marginBottom: '$spacing.sm',
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                gap: '$spacing.sm',
            }}
        >
            {uniqueCategories.map((category, index) => (
                <Box
                    as={Anchor}
                    sx={{
                        textDecoration: 'none',
                    }}
                    key={category?.id}
                    href={category.link}
                >
                    <Tag
                        textTransform="none"
                        appearance={
                            TAG_APPEARANCES_ARRAY[
                                wrap(0, TAG_APPEARANCES_ARRAY.length - 1, index)
                            ]
                        }
                    >
                        <span
                            dangerouslySetInnerHTML={{
                                __html: category.name,
                            }}
                        />
                    </Tag>
                </Box>
            ))}
        </Box>
    );
};

export default PostCategories;
